import React, { Fragment, useContext } from "react";
import CustomSwiper from "./CustomSwiper";
import CustomSwiperItem from "./CustomSwiperItem";
import { SwiperSlide } from "swiper/react";
import Loader from "../site/Loader";
import ProductContext from "../contexts/ProductContext";
import "./CustomSwiper.scss";

const GenericSwiper = ({
  items,
  isImageOnly,
  centeredSlides,
  scrollbar,
  mousewheel,
}) => {
  const context = useContext(ProductContext);
  if (items === undefined || (Array.isArray(items) && items?.length <= 0)) {
    return <></>;
  }

  const { loading } = context;

  return (
    <CustomSwiper
      centeredSlides={centeredSlides}
      className="small-items-layout"
      isBigItem={true}
      scrollbar={scrollbar}
      mousewheel={mousewheel}
    >
      {loading && <Loader />}
      {items?.map((item, index) => {
        const shouldRenderItem = !!item && !!item?.product_main_image_url;
        if (!shouldRenderItem) {
          return <Fragment key={index}></Fragment>;
        }
        return (
          <SwiperSlide key={index}>
            <CustomSwiperItem
              isImageOnly={isImageOnly}
              productId={item?.product_id}
              link={item?.promotion_link}
              image={item?.product_main_image_url}
              smallThumbs={item?.product_small_image_urls?.string}
              title={item?.product_title}
              imageAlt={
                !!item?.product_title ? item?.product_title : "no title"
              }
              category1={item?.first_level_category_name}
              currency={item?.app_sale_price_currency}
              originaPrice={item?.original_price}
              salePrice={item?.sale_price}
              videoUrl={item?.product_video_url}
            />
          </SwiperSlide>
        );
      })}
    </CustomSwiper>
  );
};

export default GenericSwiper;
